var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeIconActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.54 2.26123H7.92C9.33 2.26123 10.46 3.39734 10.46 4.79131V8.15914C10.46 9.562 9.33 10.6882 7.92 10.6882H4.54C3.14 10.6882 2 9.562 2 8.15914V4.79131C2 3.39734 3.14 2.26123 4.54 2.26123ZM4.54 13.5924H7.92C9.33 13.5924 10.46 14.7197 10.46 16.1225V19.4904C10.46 20.8833 9.33 22.0194 7.92 22.0194H4.54C3.14 22.0194 2 20.8833 2 19.4904V16.1225C2 14.7197 3.14 13.5924 4.54 13.5924ZM19.4601 2.26123H16.0801C14.6701 2.26123 13.5401 3.39734 13.5401 4.79131V8.15914C13.5401 9.562 14.6701 10.6882 16.0801 10.6882H19.4601C20.8601 10.6882 22.0001 9.562 22.0001 8.15914V4.79131C22.0001 3.39734 20.8601 2.26123 19.4601 2.26123ZM16.0801 13.5924H19.4601C20.8601 13.5924 22.0001 14.7197 22.0001 16.1225V19.4904C22.0001 20.8833 20.8601 22.0194 19.4601 22.0194H16.0801C14.6701 22.0194 13.5401 20.8833 13.5401 19.4904V16.1225C13.5401 14.7197 14.6701 13.5924 16.0801 13.5924Z",
    fill: "#F7931A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIconActive);
export default __webpack_public_path__ + "static/media/home_icon_active.961be6556c3204237450f40e6c57d377.svg";
export { ForwardRef as ReactComponent };